<template>
  <router-view/>
</template>

<style lang="less">
html, body, ul, li {
  margin: 0;
  padding: 0;
}

html {
  font-size: 62.5%; // 10px
}

li {
  list-style: none;
}

#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 1.2rem;
}

.el-drawer {
  .el-drawer__header {
    border-bottom: .1rem solid #f0f0f0;
    margin-bottom: 1rem !important;
    padding-bottom: 2rem;

    .el-drawer__title {
      font-size: 1.6rem;
      font-weight: bolder;
    }
  }

  .el-drawer__body {
    overflow-y: auto;
  }
}

.button {
  cursor: pointer;

  &:hover {
    color: #6caefa;
  }
}

.el-dialog {
  border-radius: .8rem !important;

  .el-dialog__body {
    padding: var(--el-dialog-padding-primary) !important;
    max-height: calc(100vh - 20rem);
    overflow-y: auto;
  }
}

.el-message-box {
  .el-message-box__content {
    padding: 1rem;
  }
}

.el-popper {
  min-width: 7rem !important;
}

.el-page-header {
  background: white;
  padding: 1.5rem 1rem;
  border-radius: .5rem .5rem 0 0;
  border-bottom: .1rem solid #f0f0f0;
}

.container {
  border-radius: .5rem;
  background: white;
  height: 100vh;

  .el-page-header__header {
    padding: 0 1rem !important;
  }
}

.flex {
  display: flex;
}

.flex-align-center {
  align-items: center;
  align-content: center;
}

.flex-space-between {
  justify-content: space-between;
}

.flex-flow-wrap {
  flex-flow: wrap;
}

.table {
  border-radius: .8rem;
  box-shadow: 0 0 .1rem .1rem rgba(0, 0, 0, .05);

  &.normal {
    box-shadow: none;
  }

  th {
    background: #f0f0f0 !important;
  }
}

.no-empty-table {
  .el-table__body-wrapper, .el-table__empty-block {
    display: none;
  }
}

.mt-10 {
  margin-top: 1rem;
}

.mt-15 {
  margin-top: 1.5rem;
}

.mr-8 {
  margin-right: .8rem;
}

.mr-10 {
  margin-right: 1rem;
}

.ml-10 {
  margin-left: 1rem;
}

.mr-15 {
  margin-right: 1.5rem;
}

.pd-15 {
  padding: 1.5rem;
}

.module-title {
  padding: 0 0 0 1rem;
  font-size: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  position: relative;
}

.module-title::before {
  content: '';
  width: .3rem;
  height: 1.4rem;
  background: #3f93f9;
  border-radius: .15rem;
  position: absolute;
  left: 0;
  margin-top: .1rem;
}
</style>
